"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCloseAllMenus = exports.useCloseMenu = exports.useOpenMenu = exports.useToggleMenu = exports.useOtherActiveMenu = exports.useMyActiveMenu = exports.useActiveMenu = void 0;
const react_1 = require("react");
const navActions_1 = require("../context/navActions");
const navContext_1 = require("../context/navContext");
const mobile_hooks_1 = require("./mobile.hooks");
const useActiveMenu = () => {
    const { state, dispatch } = (0, react_1.useContext)(navContext_1.NavContext);
    const setActiveMenu = (menuId) => {
        dispatch({ type: navActions_1.ActionTypes.SET_ACTIVE_MENU, value: menuId });
    };
    return (0, react_1.useMemo)(() => {
        return {
            activeMenu: state.activeMenu,
            setActiveMenu,
        };
    }, [state.activeMenu]);
};
exports.useActiveMenu = useActiveMenu;
const useMyActiveMenu = (menuId) => {
    const { activeMenu, setActiveMenu } = (0, exports.useActiveMenu)();
    const open = Boolean(activeMenu && activeMenu === menuId);
    return (0, react_1.useMemo)(() => {
        return {
            open,
            setActiveMenu,
        };
    }, [menuId, open]);
};
exports.useMyActiveMenu = useMyActiveMenu;
const useOtherActiveMenu = (menuId) => {
    const { activeMenu, setActiveMenu } = (0, exports.useActiveMenu)();
    const open = Boolean(activeMenu && activeMenu === menuId);
    const otherOpen = Boolean(activeMenu && activeMenu !== menuId);
    return (0, react_1.useMemo)(() => {
        return {
            open,
            otherOpen,
            setActiveMenu,
        };
    }, [menuId, open, otherOpen]);
};
exports.useOtherActiveMenu = useOtherActiveMenu;
const useToggleMenu = (menuOpen, setMenuOpen, menuId) => {
    const { setActiveMenu } = (0, exports.useActiveMenu)();
    const toggleMenu = (0, react_1.useCallback)((e) => {
        if (e) {
            e.preventDefault();
        }
        const newValue = !menuOpen;
        setMenuOpen(newValue);
        setActiveMenu(newValue ? menuId : "");
    }, [menuOpen, setMenuOpen, menuId]);
    return toggleMenu;
};
exports.useToggleMenu = useToggleMenu;
const useOpenMenu = (menuId) => {
    const { setActiveMenu } = (0, exports.useActiveMenu)();
    const openMenu = (0, react_1.useCallback)(() => {
        setActiveMenu(menuId);
    }, [menuId]);
    return openMenu;
};
exports.useOpenMenu = useOpenMenu;
const useCloseMenu = () => {
    const { setActiveMenu } = (0, exports.useActiveMenu)();
    const closeMenu = (0, react_1.useCallback)(() => {
        setActiveMenu("");
    }, []);
    return closeMenu;
};
exports.useCloseMenu = useCloseMenu;
const useCloseAllMenus = () => {
    const { setActiveMenu } = (0, exports.useActiveMenu)();
    const { setMobileMenuOpen } = (0, mobile_hooks_1.useMobileMenu)();
    const { setMenuOpen: setLocaleMobileTrayOpen } = (0, mobile_hooks_1.useLocaleMobileTray)();
    const { setMenuOpen: setSignInTrayOpen } = (0, mobile_hooks_1.useSignInMobileTray)();
    const { setInnerMobileMenu } = (0, mobile_hooks_1.useInnerMobileMenu)();
    const closeAllMenus = (0, react_1.useCallback)(() => {
        setActiveMenu("");
        setMobileMenuOpen(false);
        setLocaleMobileTrayOpen(false);
        setSignInTrayOpen(false);
        setInnerMobileMenu("");
    }, [setMobileMenuOpen, setLocaleMobileTrayOpen, setSignInTrayOpen, setInnerMobileMenu]);
    return closeAllMenus;
};
exports.useCloseAllMenus = useCloseAllMenus;
//# sourceMappingURL=menu.hooks.js.map